import React from 'react';
import LocalStorageHandler from './Components/LocalStorage/LocalStorageHandler';
import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary';
import Navbar from './Components/Navbar/Navbar';
import LoginPage from './Components/LoginPage/LoginPage';
import WebSocketClient from './Components/WebSocketClient/WebSocketClient';
import OpenVpnStats from './Components/OpenVpnStats';
import Development from './Components/Development';

class App extends React.Component {
    constructor(props) {
        super(props);

        // console.clear();

        this.state = {
            theme: '',
            ws: null,
            loggedIn: false,
            messages: [],
        };
        [this.host, this.port, this.ws] = Development();

        this.message = [];

        this.logoutDelay = 5000;
        this.logoutTimer = null;

        this.wsClientId = 'websocket1';

        this.storage = new LocalStorageHandler({ setStateCallback: this.setState.bind(this) });

        this.updateRootClass = this.updateRootClass.bind(this);
        this.websocketMessageReceived = this.websocketMessageReceived.bind(this);
        this.websocketMessageError = this.websocketMessageError.bind(this);
        this.websocketMessageRefreshToken = this.websocketMessageRefreshToken.bind(this);
        this.websocketMessageOpenVpnStats = this.websocketMessageOpenVpnStats.bind(this);
    }

    updateRootClass(prevState) {
        if (prevState.theme !== this.state.theme) {
            document.body.className = '';
            document.body.classList.add(`bg-${this.state.theme}`);
            document.body.classList.add(`text-${this.state.theme === 'dark' ? 'light' : 'dark'}`);

            // document.body.dataset.bsTarget = `${this.state.theme === 'dark' ? 'dark' : 'light'}`;
            this.storage.setItem('theme', this.state.theme);
        }
    }

    websocketMessageReceived(prevState) {
        this.websocketMessageError(prevState);
        this.websocketMessageRefreshToken(prevState);
        this.websocketMessageOpenVpnStats(prevState);
    }

    websocketMessageError() {
        const { error } = this.state?.ws?.message?.[this.wsClientId];
        if (error) {
            if (!this.logoutTimer) {
                this.logoutTimer = setTimeout(() => {
                    this.setState({ loggedIn: false });
                    this.setState({ loggedOutReason: "Session expired" });
                    this.storage.setItem('token', '');
                    this.storage.setItem('username', '');
                    this.storage.setItem('token_type', '');
                }, this.logoutDelay);
            }
        } else {
            if (this.logoutTimer) {
                clearTimeout(this.logoutTimer);
                this.logoutTimer = null;
            }
        }
    }

    websocketMessageRefreshToken(prevState) {
        const { token } = this.state?.ws?.message?.[this.wsClientId];
         if (token && token !== prevState?.token) {
            this.storage.setItem('token', token);
            this.setState({token: token});
        }
    }

    websocketMessageOpenVpnStats(prevState) {
        const { message } = this.state?.ws?.message?.[this.wsClientId];
        if (message && message !== prevState?.OpenVpnStats) {
            this.setState({ OpenVpnStats: message });
        }
    }

    componentDidMount() {
        if (this.storage.local.theme) {
            this.setState({ theme: this.storage.local.theme });
        }
        if (this.storage.local.token && this.storage.local.username && this.storage.local.token_type === 'jwt') {
            this.setState({ loggedIn: true });
        }
        if(this.storage.local.token) {
            this.setState({ token: this.storage.local.token });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this.updateRootClass(prevState);

        if (this.state.loggedIn && this.state?.ws?.message?.[this.wsClientId]) {
            this.websocketMessageReceived(prevState);
        }
    }

    render() {
        return (
            <ErrorBoundary>
                {this.state.loggedIn ?
                    <>
                        <Navbar
                            theme={this.state.theme}
                            updateThemeCallback={(theme) => this.setState({ theme })}
                            updateLoginCallback={(loggedIn) => this.setState({ loggedIn })}
                        />
                        <OpenVpnStats
                            theme={this.state.theme}
                            OpenVpnStats={this.state.OpenVpnStats}
                            wsState={this.state?.ws?.[this.wsClientId].readyState}
                            sort={this.state.sort}
                            setSortCallback={(sort) => this.setState((prevState) => {
                                if (!this.state?.sort?.direction) {
                                    sort.direction = 'asc';
                                } else {
                                    if (this.state.sort.column === sort.column) {
                                        sort.direction = this.state.sort.direction === 'asc' ? 'desc' : 'asc';
                                    } else {
                                        sort.direction = 'asc';
                                    }
                                }

                                return {
                                    ...prevState,
                                    sort: sort
                                }
                            })}
                        />
                        <WebSocketClient
                            url={`${this.ws}://${this.host}${this.port}/websocket`}
                            name={this.wsClientId}
                            ws={this.state.ws}
                            token={this.state.token}
                            username={this.storage.local.username}
                            refreshToken={this.storage?.local?.rememberMe ? JSON.parse(this.storage.local.rememberMe) : false}
                            setWsCallback={(ws) => this.setState((prevState) => {
                                if (!ws?.name) {
                                    return
                                }
                                return {
                                    ...prevState,
                                    ws: {
                                        ...prevState.ws,
                                        [ws.name]: ws
                                    }
                                }
                            })}
                            setMessageCallback={(payload) => this.setState((prevState) => {
                                return {
                                    ...prevState,
                                    ws: {
                                        ...prevState.ws,
                                        message: {
                                            ...prevState.ws.message,
                                            [payload.name]: payload.message
                                        }
                                    }
                                }
                            })}
                        />
                    </>
                    :
                    <LoginPage
                        theme={this.state.theme}
                        appName={"VPN clients monitoring"}
                        loggedOutReason={this.state?.loggedOutReason}
                        host={this.host}
                        port={this.port}
                    />
                }
            </ErrorBoundary>
        );
    }
}

export default App;
